<template>
  <jtCard
    containerHeight="429"
    title="集装箱堆场到发情况"
    style="margin-bottom: 30px"
  >
    <div class="container">
      <div
        class="chart"
        id="containergoods"
        style="width: 100%; height: 350px"
      ></div>
    </div>
  </jtCard>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
import jtCard from "@/components/Card";
export default {
  components: {
    jtCard,
  },
  props: {
    tbContainerYards: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    let _this = this;
    // 在mouted里面做了一个立即执行函数 ，防止里面的变量污染
    (function () {
      //下面和eacharts差不多
      const container = document.getElementById("containergoods");
      const myChart = new Charts(container);
      const option = {
        // title: {
        //   text: '周销售额趋势'
        // },
        tooltip: {
					trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
					axisPointer: {// 坐标轴指示器，坐标轴触发有效
						type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
					}
        },
        legend: {
          show:true,
          top: 40,
          itemGap:50,
          // left:180,
          textStyle: {
            fill: "#5BB0FF",
            fontSize: 20,
          },
          textUnselectedStyle: {
            fontFamily: 'Arial',
            fontSize: 13,
            fill: '#2DF9CC'
          },
          data: [
            { name: "今日进", color: "#39FE63" ,icon:'rect'},
            { name: "今日出", color: "#FCCC24" ,icon:'rect'},
            { name: "今日结存", color: "#0E9CFF",icon:'rect'},
          ],
        },

        xAxis: {
          name: '日期',
          // data: ['h1', 'h1', 'h1', 'h1', 'h1', 'h1', 'h1'],
          data:_this.tbContainerYards.documentDate,
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
          axisTick:{
            show: false
          }
        },
        yAxis: {
          name: '吨',
          data: 'value',
          axisLine: {
            style: {
              borderType: "dashed",
              stroke: '#333',
            },
            show:false
          },
          splitLine:{
            show: true,
          },
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },

        },
        series: [
          {
            name: "今日进",
            // data: [120, 223, 190, 210, 350, 220, 308],
            data:_this.tbContainerYards.containerInoutTodayWeight,
            type: 'line',
            lineStyle: {
              stroke: "#39FE63",
              lineWidth: 4
            },
            linePoint: {
              radius: 6,
              style: {
                fill: "#39FE63",
                stroke: "transparent",
              },
            } 
          },
          {
            name: "今日出",
            // data: [280, 273, 320, 410, 120, 510, 420],
            data:_this.tbContainerYards.containerInoutTodayAir,
            type: 'line',
            lineStyle: {
              stroke: "#FCCC24",
              lineWidth: 4
            },
            linePoint: {
              radius: 6,
              style: {
                fill: "#FCCC24",
                stroke: "transparent",
              },
            },

          },
          {
            name: "今日结存",
            // data: [390, 403, 400, 600, 390, 620, 308],
            data:_this.tbContainerYards.containerBalanceTodayAir,
            type: 'line',
            lineStyle: {
              stroke: "#0E9CFF",
              lineWidth: 4
            },
            linePoint: {
              radius: 6,
              style: {
                fill: "#0E9CFF",
                stroke: "transparent",
              },
            },

          }
        ]
       
      };

      myChart.setOption(option);

      //图表自适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    })();
  },
  methods: {},
};
</script>
<style scoped>
.chart {
  height: 240px;
  margin-left: 15px;
}

h2 {
  height: 48px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 48px;
}
</style>

